// Module
var code = "<div>\n  <div\n    ng-dropdown-multiselect\n    options=\"vm.users\"\n    selected-model=\"vm._selectedUsers\"\n    extra-settings=\"vm.selectOptions\"\n    events=\"vm.multiselectEvents\"\n    data-cy=\"user-select\"\n    style=\"display: inline-block\"\n  ></div>\n</div>\n";
// Exports
module.exports = code;